import * as actionTypes from "./actionTypes";

const initialState = {
  rows: [],
  instances: [],
  dateFormat: "yyyy/mm/dd",
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_STATE:
      return initialState;

    case actionTypes.GET_ROWS:
      return { ...state, isLoading: true };
    case actionTypes.GET_ROWS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        rows: action.payload.rows,
        dateFormat: action.payload.dateFormat,
      };
    case actionTypes.GET_ROWS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_INSTANCES:
      return { ...state, isLoading: true };
    case actionTypes.GET_INSTANCES_FULFILLED:
      return {
        ...state,
        isLoading: false,
        instances: action.payload.instances,
      };
    case actionTypes.GET_INSTANCES_REJECTED:
      return { ...state, isLoading: false };

      case actionTypes.UPLOAD_DOCUMENT:
      return { ...state, isLoading: true };
    case actionTypes.UPLOAD_DOCUMENT_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.UPLOAD_DOCUMENT_REJECTED:
      return { ...state, isLoading: false };

    default:
      return state;
  }
}
